import React from 'react';

// Skeleton para KPI cards
export function KPISkeleton() {
  return (
    <div className="animate-pulse bg-gradient-to-br from-gray-100 to-white rounded-xl border border-gray-200 p-4">
      <div className="h-4 bg-gray-200 rounded w-24 mb-3"></div>
      <div className="h-8 bg-gray-300 rounded w-16 mb-1"></div>
      <div className="h-3 bg-gray-200 rounded w-20"></div>
    </div>
  );
}

// Skeleton para fila de tabla
export function TableRowSkeleton({ columns = 5 }) {
  return (
    <tr className="border-b">
      {Array.from({ length: columns }).map((_, i) => (
        <td key={i} className="py-3 px-3">
          <div className="animate-pulse h-4 bg-gray-200 rounded w-full"></div>
        </td>
      ))}
    </tr>
  );
}

// Skeleton para tabla completa
export function TableSkeleton({ rows = 5, columns = 5 }) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b bg-slate-50">
            {Array.from({ length: columns }).map((_, i) => (
              <th key={i} className="py-2 px-3">
                <div className="animate-pulse h-4 bg-gray-300 rounded w-20"></div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, i) => (
            <TableRowSkeleton key={i} columns={columns} />
          ))}
        </tbody>
      </table>
    </div>
  );
}

// Skeleton para dashboard de Derivaciones
export function DerivacionesSkeleton() {
  return (
    <div className="space-y-6">
      {/* Header skeleton */}
      <div className="flex items-center justify-between">
        <div className="animate-pulse h-6 bg-gray-200 rounded w-48"></div>
        <div className="flex gap-2">
          <div className="animate-pulse h-9 bg-gray-200 rounded w-32"></div>
          <div className="animate-pulse h-9 bg-gray-200 rounded w-28"></div>
        </div>
      </div>
      
      {/* KPI cards skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
        {Array.from({ length: 5 }).map((_, i) => (
          <KPISkeleton key={i} />
        ))}
      </div>
      
      {/* Table skeleton */}
      <div className="bg-white rounded-xl border p-4">
        <div className="animate-pulse h-5 bg-gray-200 rounded w-40 mb-4"></div>
        <TableSkeleton rows={8} columns={6} />
      </div>
    </div>
  );
}

// Skeleton para dashboard de Reincidencia
export function ReincidenciaSkeleton() {
  return (
    <div className="space-y-6">
      {/* Header skeleton */}
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="animate-pulse h-6 bg-gray-200 rounded w-56"></div>
        <div className="flex gap-2">
          <div className="animate-pulse h-9 bg-gray-200 rounded w-36"></div>
          <div className="animate-pulse h-9 bg-gray-200 rounded w-28"></div>
          <div className="animate-pulse h-9 bg-gray-200 rounded w-16"></div>
        </div>
      </div>
      
      {/* Info box skeleton */}
      <div className="animate-pulse h-16 bg-blue-50 rounded-lg"></div>
      
      {/* KPI cards skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <KPISkeleton key={i} />
        ))}
      </div>
      
      {/* Table skeleton */}
      <div className="bg-white rounded-xl border p-4">
        <div className="flex items-center justify-between mb-4">
          <div className="animate-pulse h-5 bg-gray-200 rounded w-48"></div>
          <div className="animate-pulse h-8 bg-gray-200 rounded w-28"></div>
        </div>
        <TableSkeleton rows={10} columns={5} />
      </div>
    </div>
  );
}

export default { KPISkeleton, TableRowSkeleton, TableSkeleton, DerivacionesSkeleton, ReincidenciaSkeleton };
